const empNumber = (value: unknown) => {
  const text = String(value ?? "").trim();
  return /^\d+$/.test(text) ? text.padStart(8, "0") : text;
};

export const canReviewMutualExchange = (record: any, approverId: unknown): boolean => {
  if (!record || !empNumber(approverId)) return false;
  if (String(record.status || record.exchangeStatus || "").toUpperCase() !== "PENDING") return false;
  if ([false, "false", 0, "0"].includes(record.actionRequired)) return false;
  const steps = [record.approvalDetails, record.approvals, record.approverDetails]
    .find(Array.isArray) || [];
  const active = record.activeApproval || record.currentApprover ||
    steps.find((step: any) => [true, "true", 1, "1"].includes(step.isAssigned));
  if (active) {
    const step = steps.find((item: any) => active.id != null
      ? String(item.id) === String(active.id)
      : Number(item.stage) === Number(active.stage)) || active;
    return empNumber(active.approverId || active.empId || step.approverId || step.empId) === empNumber(approverId) &&
      String(step.status || active.status || "PENDING").toUpperCase() === "PENDING";
  }
  if (steps.length) return false;
  return !record.myConsentStage || String(record.myConsentStage.status).toUpperCase() === "PENDING";
};

export const mapMutualExchange = (record: any) => {
  const employee = (index: number) => {
    const prefix = `emp${index}`;
    const nested = record[prefix] || {};
    return {
      ...nested,
      empNo: empNumber(nested.empNo ?? record[`${prefix}Id`]),
      name: String(nested.name ?? record[`${prefix}Name`] ?? ""),
      designation: nested.designation ?? record[`${prefix}Designation`] ?? "",
      department: nested.department ?? record[`${prefix}Department`] ?? "",
      quarterNo: nested.quarterNo ?? record[`${prefix}FlatNumber`] ?? "",
      flatId: nested.flatId ?? record[`${prefix}FlatId`],
      block: nested.block ?? record[`${prefix}Block`],
      quarterType: nested.quarterType ?? record[`${prefix}QuarterType`] ?? "",
      quarterTypeCode: nested.quarterTypeCode ?? record[`${prefix}QuarterTypeCode`],
      pool: nested.pool ?? record[`${prefix}Pool`] ?? "",
      location: String(nested.location ?? record[`${prefix}Location`] ?? ""),
      lastOccupationDate: record[`${prefix}LastOccupationDate`] !== undefined
        ? record[`${prefix}LastOccupationDate`]
        : nested.lastOccupationDate,
      postExchangeOccupationDate: record[`${prefix}PostExchangeOccupationDate`] !== undefined
        ? record[`${prefix}PostExchangeOccupationDate`]
        : nested.postExchangeOccupationDate,
      controllingOfficerEmp: nested.controllingOfficerEmp ?? record[`controllingOfficerEmp${index}`],
    };
  };
  return {
    ...record,
    id: String(record.id ?? record.mutualExchangeId ?? record.applicationId ?? ""),
    referenceNo: String(record.referenceNo ?? record.referenceNumber ?? ""),
    emp1: employee(1),
    emp2: employee(2),
    status: String(record.status ?? record.exchangeStatus ?? "PENDING").toUpperCase(),
    reason: record.reason ?? record.remarks ?? "",
  };
};

export const readMutualExchanges = (response: any): any[] => {
  if (Array.isArray(response)) return response.map(mapMutualExchange);
  if (response && typeof response === "object") {
    for (const key of ["data", "exchanges", "employeeExchanges", "records", "items"]) {
      if (response[key] != null) return readMutualExchanges(response[key]);
    }
  }
  throw new Error("The mutual exchange response does not contain an application list.");
};
